import { gql } from '@apollo/client'

export const FRAGMENT_COMPANY = gql`
  fragment FragmentCompany on Company {
    id
  }
`
